var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 8.2998C2.3999 6.64269 3.74412 5.2998 5.40071 5.2998H19.7991C20.7927 5.2998 21.5999 6.10518 21.5999 7.0998V8.52466C21.5999 9.27018 21.1403 9.93855 20.4442 10.2054L13.2258 12.9724C12.4222 13.2805 11.525 13.2286 10.7623 12.8299L5.12195 9.88154C4.82828 9.72803 4.71466 9.36552 4.86817 9.07185C5.02168 8.77818 5.38419 8.66456 5.67786 8.81807L11.3182 11.7664C11.7758 12.0056 12.3141 12.0368 12.7963 11.8519L20.0147 9.08491C20.2467 8.99596 20.3999 8.77317 20.3999 8.52466V7.0998C20.3999 6.76894 20.131 6.4998 19.7991 6.4998H5.40071C4.40634 6.4998 3.5999 7.30596 3.5999 8.2998V16.6998C3.5999 17.6939 4.40579 18.4998 5.3999 18.4998H18.5999C19.5943 18.4998 20.3999 17.6945 20.3999 16.7006V11.8998C20.3999 11.5684 20.6685 11.2998 20.9999 11.2998C21.3313 11.2998 21.5999 11.5684 21.5999 11.8998V16.7006C21.5999 18.3577 20.2565 19.6998 18.5999 19.6998H5.3999C3.74305 19.6998 2.3999 18.3567 2.3999 16.6998V8.2998Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.077cfb1b8f2312db83935f3d503fd44b.svg";
export { ForwardRef as ReactComponent };